import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { getPropertyValue } from 'framework-listing-lib/utils/crmObject';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Link } from 'foundations-components/transitional/components/Link';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import EmbedVersions from 'forms-utils-lib/constants/formDefinition/EmbedVersions';
import { hasFormsWriteAccess } from 'FormsUI/selectors/Scope';
import { extractCosIndexObjectsFromReferenceRecords } from 'FormsUI/api/referenceResolvers/utils';
import ResolveReferencesToCosIndexConnectionsParents from 'FormsUI/api/referenceResolvers/hocs/ResolveReferencesToCosIndexConnectionsParents';
import { PROPERTIES } from 'FormsUI/components/dashboard/frameworkTable/constants';
import { getNonDeletableFormReason } from '../utils';
import { DeleteIcon } from 'foundations-assets/icons/components/DeleteIcon';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const DeleteButton = ({
  onClick,
  selectedObjects,
  cosIndexObjectReferenceRecords
}) => {
  const canWriteToForms = useSelector(hasFormsWriteAccess);
  const cosIndexObjectsMap = useMemo(() => extractCosIndexObjectsFromReferenceRecords(cosIndexObjectReferenceRecords), [cosIndexObjectReferenceRecords]);
  const containsV4Form = useMemo(() => selectedObjects.some(crmObject => getPropertyValue(crmObject, PROPERTIES.EMBED_VERSION) === EmbedVersions.V4), [selectedObjects]);
  const {
    isDisabled,
    reason
  } = selectedObjects.reduce((acc, cur) => {
    if (acc.isDisabled) return acc;
    const formId = getPropertyValue(cur, PROPERTIES.FORM_ID);
    const currentReason = getNonDeletableFormReason(cur, cosIndexObjectsMap[formId]);
    const currentIsDisabled = currentReason !== null;
    return {
      reason: currentReason,
      isDisabled: currentIsDisabled
    };
  }, {});
  const tooltipTitle = useMemo(() => {
    if (containsV4Form) {
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "permissions.betaDeleteDisabled"
      });
    }
    if (!canWriteToForms) return /*#__PURE__*/_jsx(FormattedMessage, {
      message: "permissions.disallowed"
    });
    if (isDisabled) {
      return reason;
    }
    return null;
  }, [canWriteToForms, containsV4Form, isDisabled, reason]);
  const disableDelete = useMemo(() => isDisabled || !canWriteToForms || containsV4Form, [canWriteToForms, containsV4Form, isDisabled]);
  return /*#__PURE__*/_jsx(Tooltip, {
    disabled: !disableDelete,
    title: tooltipTitle,
    children: /*#__PURE__*/_jsxs(Link, {
      disabled: disableDelete,
      onClick: onClick,
      "data-action": "bulk-delete",
      children: [/*#__PURE__*/_jsx(DeleteIcon, {}), /*#__PURE__*/_jsx(FormattedMessage, {
        message: "delete"
      })]
    })
  });
};
export default ResolveReferencesToCosIndexConnectionsParents({
  target: DeleteButton,
  mapPropsToFormIds: ({
    selectedObjects
  }) => selectedObjects.map(form => getPropertyValue(form, PROPERTIES.FORM_ID))
});